<div class="modal-header navbar navbar-dark navbar-expand-lg">
  <img src="assets/images/logo-text.webp" style="height: 1.5rem; border: none; margin: 0px; padding: 0px; position: relative; top: -0.20rem;" class="ms-3">
  <button #menu class="navbar-toggler my-toggler me-1" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbarModal" aria-controls="offcanvasNavbarModal">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="offcanvas offcanvas-end" style="width: 20rem;" tabindex="-1" id="offcanvasNavbarModal"
    aria-labelledby="offcanvasNavbarLabel">
    <div class="offcanvas-header mb-0 pb-0 statusbar-padding">
      <img src="assets/images/logo-text.webp" style="height: 1.5rem; border: none; margin: 0px; padding: 0px;">
    </div>
    <div class="offcanvas-body">
      <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
        <li class="nav-item">
          <a class="nav-link" data-bs-dismiss="offcanvas" routerLink="/signout" (click)="activeModal.close()">
            <fa-icon [icon]="fa.faSignOutAlt"></fa-icon>
            <span class="d-lg-none ms-1" i18n>Sign out</span>
          </a>
        </li>
        <li class="nav-item">
          <a (click)="languageSelector()" class="nav-link cursor-pointer" data-bs-dismiss="offcanvas">
            <ng-container *ngIf="organization">
              <img [src]="'assets/images/flags/' + organization.country_code.toLocaleLowerCase() + '.webp'" style="height: 1rem; border: none; position: relative; top: -1px;" class="me-1">
              {{ locale | i18nSelect: locales }}
            </ng-container>
            <ng-container *ngIf="!organization">
              <fa-icon [icon]="fa.faGlobe"></fa-icon>&nbsp;
              <ng-container>{{ locale | i18nSelect: locales }}</ng-container>
            </ng-container>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
<div class="modal-body" style="height: calc(100vh - 4.8rem);">
  <div class="d-flex justify-content-center align-items-center">
    <div class="container">
      <div class="row d-flex justify-content-center">
        <div class="col-12 col-md-10 col-lg-8">
          <div class="card">
            <div class="card-body p-4">
              <ng-container #modalOutlet></ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
